'use strict';

var draftToMarkdown = require('./draft-to-markdown');
var markdownToDraft = require('./markdown-to-draft');

module.exports = { draftToMarkdown: draftToMarkdown, markdownToDraft: markdownToDraft };


//////////////////
// WEBPACK FOOTER
// ./~/markdown-draft-js/lib/index.js
// module id = 593
// module chunks = 0